export default __webpack_public_path__ + "static/media/Thumb-8.07d0a2c3.png";